import HomeScreen from "./HomeScreen";

export default HomeScreen;